import { RefObject, useEffect, useState } from 'react';

type useTextOverflowProps = {
  containerRef: RefObject<HTMLDivElement>;
  text: string;
};

const useTextOverflow = ({ containerRef, text }: useTextOverflowProps) => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (containerRef?.current) {
      setIsOverflowing(containerRef.current.scrollWidth > containerRef.current.clientWidth);
    }
  }, [containerRef, text, setIsOverflowing]); // text is required to re-compute overflow when it changes

  return { isOverflowing };
};

export default useTextOverflow;
